export function OfficePreview(props: { url: string; }) {
    return (
        <iframe
            title="Document"
            src={'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(props.url) + '&wdDownloadButton=false'}
            height="100%"
            width="100%"
        ></iframe>
    );
}
